import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    addresses:null,
    loading: false,
    error:null
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_ADDRESSES_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_ADDRESSES_SUCCESS: 
            return updateObject(state, {loading:false, addresses:action.payload.addresses});
        case actionTypes.FETCH_ADDRESSES_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, addresses:null});
        default: 
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/address.js